import ValidationInterface from '@/plans/common/validation-interface';
import {
  basePlanCategories, bizPlusCategories, eduPlusCategories, SDKCategories, zrCategories,
} from "@/common/persist-cart/categories";
import { BILLING_CYCLE } from "@/common/constants";

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current(["tollfree"]).require([...basePlanCategories, ...SDKCategories], { licenseMatch: false }),
      this.current(["tollfree_us_ca"]).require(["biz", "zoneduschcmp"], {
        licenseEqual: (cart) => {
          return cart.getAllPlans().filter((p) => ["biz", "zoneduschcmp", ...zrCategories].includes(p.category));
        },
      }),
    ];
  }

  async conflicts() {
    return [
      ...this.current(["tollfree"]).conflict(["tollfree"]),
      ...this.current(["tollfree_us_ca"]).conflict([...bizPlusCategories, ...eduPlusCategories]),
    ];
  }
}

//todo UI restriction audio pay as you just require biz or zoneduschcmp
export class AudioPayAsYouGoRule extends ValidationInterface {
  async conflicts() {
    const conflictCategories = basePlanCategories.filter((c) => !["biz", "zoneduschcmp"].includes(c));
    return function getConflictingPlans(cart, planToAdd) {
      //not tollfree and not base plan
      if (planToAdd.category !== "tollfree" && !conflictCategories.includes(planToAdd.category)) {
        return [];
      }

      const cartPlans = cart.getAllPlans();

      if (conflictCategories.includes(planToAdd.category)) {
        return cartPlans.filter((p) => p.category === "tollfree" && p.billingCycle === BILLING_CYCLE.PAY_AS_YOU_GO);
      }

      if (planToAdd.category === "tollfree" && planToAdd.billingCycle === BILLING_CYCLE.PAY_AS_YOU_GO) {
        return cartPlans.filter((p) => conflictCategories.includes(p.category));
      }
      return [];
    };
  }
}
